export default "__VITE_ASSET__DOvizgGR__"